import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'lib-skeleton-form',
  templateUrl: './skeleton-form.component.html',
  styleUrl: './skeleton-form.component.css'
})
export class SkeletonFormComponent implements OnInit {
  @Input() numberOfRows: number = 6; 
  skeletonRows: number[] = [];


  ngOnInit(): void {
    this.skeletonRows = Array(this.numberOfRows).fill(0);
  }
}
